import { GetStateFromSelectors } from '../reselectTypes';

import createCustomSelectorHook from './createCustomSelectorHook';
import { Combiner, RootSelector, SelectorArray } from './types';

const rootSelectorHook = createCustomSelectorHook('root');

const createRootSelector = <Result, Selectors extends SelectorArray>(
  ...selectorsList: [...Selectors, Combiner<Selectors, Result>]
): RootSelector<GetStateFromSelectors<Selectors>, Result> =>
  rootSelectorHook(...selectorsList) as RootSelector<
    GetStateFromSelectors<Selectors>,
    Result
  >;

export default createRootSelector;
